import ResourceTable, { ResourceTableProps } from './ResourceTable';

export type { ResourceTableProps };

export default ResourceTable;
